import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Button from 'Components/Button';
import PrimaryButton from 'Components/Button/PrimaryButton';
import TextInput from 'Components/forms/text-input/TextInput';
import OutsideClickHandler from 'Components/OutsideClickHandler';

import './GDNewFilterDropdown.scss';
import { COLORS } from "Constants/BIDashboardConstants.js"

const GDNewFilterDropdown = ({
  extraClass,
  onChange,
  saveFilterName,
  toggleDropdown,
  translations,
  value,
}) => {
  const wrapperClass = classnames('gd-new-filter-dropdown', {
    [extraClass]: extraClass,
  });

  const disabled = value.trim().length < 3;
  const acquirerCode = JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode;

  return (
    <OutsideClickHandler onClickOutside={toggleDropdown}>
      <div className={wrapperClass}>
        <h1 className={"gd-new-filter-dropdown__header" + acquirerCode}>{translations.saveFilterTitle}</h1>
        <div className="gd-new-filter-dropdown__content">
          <TextInput
            name="filterName"
            label={translations.saveFilterLabel}
            types="text"
            value={value}
            onChange={onChange}
            extraStyle={acquirerCode == "HPY" ? { fontSize: 12, fontWeight: 500, color: '#203645' } : { fontSize: 12, fontWeight: 500, color: COLORS.oneGp.black }}
          />
        </div>
        <div className={"gd-new-filter-dropdown__footer" + acquirerCode}>
          <Button style={{ color: acquirerCode == "HPY" ? "#828D98" : "" }}
            action={toggleDropdown}
          >
            {translations.cancel}
          </Button>
          <PrimaryButton style={acquirerCode == "HPY" ? { backgroundColor: "#1362e2", border: "2px solid #1362e2", color: "#ffffff" } : {}}
            action={saveFilterName}
            disabled={disabled}
          >
            {translations.save}
          </PrimaryButton>
        </div>
      </div>
    </OutsideClickHandler>
  );
};

GDNewFilterDropdown.propTypes = {
  extraClass: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  saveFilterName: PropTypes.func.isRequired,
  toggleDropdown: PropTypes.func.isRequired,
  translations: PropTypes.object,
  value: PropTypes.string,
};

GDNewFilterDropdown.defaultProps = {
  extraClass: '',
  translations: {
    saveFilterLabel: 'Filter Name',
    saveFilterTitle: 'Save Filter',
  },
  value: '',
};

export default GDNewFilterDropdown;
